import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';

import { AuthProvider, useAuth } from './contexts/AuthContext';
import { SocketProvider }        from './contexts/SocketContext';

import LoginPage    from './pages/LoginPage';
import Layout       from './components/layout/Layout';
import Dashboard    from './pages/Dashboard';
import ChatDirect   from './pages/ChatDirect';
import ChatGroup    from './pages/ChatGroup';
import Groups       from './pages/Groups';
import VideoMeeting from './pages/VideoMeeting';
import Files        from './pages/Files';
import Archive      from './pages/Archive';
import Circulars    from './pages/Circulars';
import Decisions    from './pages/Decisions';
import Calendar     from './pages/CalendarPage';
import KPI          from './pages/KPI';
import Reports      from './pages/Reports';
import AIAssistant  from './pages/AIAssistant';
import Users        from './pages/Users';
import ActivityLog  from './pages/ActivityLog';
import Security     from './pages/Security';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-screen"><div className="spinner"/><span style={{color:'var(--t3)',fontSize:12}}>جارٍ التحميل...</span></div>;
  return user ? children : <Navigate to="/login" replace />;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/login" element={<LoginPage />} />
    <Route path="/" element={<PrivateRoute><SocketProvider><Layout /></SocketProvider></PrivateRoute>}>
      <Route index          element={<Dashboard />} />
      <Route path="chat"    element={<ChatDirect />} />
      <Route path="groups-chat" element={<ChatGroup />} />
      <Route path="groups"  element={<Groups />} />
      <Route path="video"   element={<VideoMeeting />} />
      <Route path="files"   element={<Files />} />
      <Route path="archive" element={<Archive />} />
      <Route path="circulars"  element={<Circulars />} />
      <Route path="decisions"  element={<Decisions />} />
      <Route path="calendar"   element={<Calendar />} />
      <Route path="kpi"        element={<KPI />} />
      <Route path="reports"    element={<Reports />} />
      <Route path="ai"         element={<AIAssistant />} />
      <Route path="users"      element={<Users />} />
      <Route path="log"        element={<ActivityLog />} />
      <Route path="security"   element={<Security />} />
    </Route>
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <ToastContainer
          position="top-left"
          autoClose={3500}
          rtl={true}
          style={{ fontFamily: 'Cairo, sans-serif', fontSize: 12 }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}
